import { render, staticRenderFns } from "./MobDocumentCard.vue?vue&type=template&id=2664eb25&scoped=true"
import script from "./MobDocumentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MobDocumentCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobDocumentCard.vue?vue&type=style&index=0&id=2664eb25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664eb25",
  null
  
)

export default component.exports